import { Injectable } from '@angular/core';
import { Router, Route, ActivatedRoute } from '@angular/router';
import { NavigationService } from './navigation.service';

export interface ErrorNavData {
  message: string;
  code: string;
  buttonText?: string;
  autoexecute?: number;
  // tslint:disable-next-line: ban-types
  action?: Function;
}

@Injectable()
export class ErrorService {

  error: ErrorNavData;
  errorId = 0;

  constructor(
    private nav: NavigationService
  ) { }


  go(error: ErrorNavData, back = false) {
    this.errorId++;
    this.error = Object.assign(
      {
        message: 'Houve uma falha desconhecida',
        buttonText: back
          ? '<i class="fa fa-chevron-left"></i> &nbsp;&nbsp; Voltar'
          : '<i class="fa fa-home"></i> &nbsp;&nbsp; Ir para início'
      },
      error
    );

    if (back) {
      this.nav.goAndReturn(['error']);
    } else {
      this.nav.go(['error']);
    }
  }
}
